import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Footer from "./Footer";
import Header from "./Header";
import "./../../stylesheets/components/_Layout.scss";
import PrivacyButton from "../PrivacyButton";
import { useMediaQuery, useTheme } from "@mui/material";

export default function Layout(props: { children?: React.ReactNode }) {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ pb: 7 }}>
      <Header />
      <Container sx={{ mt: 8, mb: 4 }}>
        <main>{props.children}</main>
      </Container>
      <PrivacyButton />
      {sm && <Footer />}
    </Box>
  );
}
